import { render, staticRenderFns } from "./AgendamentoGrid.vue?vue&type=template&id=25482336"
import script from "./AgendamentoGrid.vue?vue&type=script&lang=js"
export * from "./AgendamentoGrid.vue?vue&type=script&lang=js"
import style0 from "./AgendamentoGrid.vue?vue&type=style&index=0&id=25482336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports